<template>
    <div class="d-flex h-3em justify-content-center align-items-center user-select-none">
        <span class="font-size-sm text-uppercase text-primary">{{ agency.name }}</span>
    </div>
</template>

<script>
export default {
    name: 'Agency',

    props: {
        agency: Object
    },
}
</script>
